import { styled } from '../../Utilities';
import { DatePickerBase } from './DatePicker.base';
import { styles } from './DatePicker.styles';
/**
 * DatePicker description
 */
export var DatePicker = styled(DatePickerBase, styles, undefined, {
    scope: 'DatePicker',
});
//# sourceMappingURL=DatePicker.js.map


//////////////////
// WEBPACK FOOTER
// /home/travis/build/proofdict/proofdict/node_modules/office-ui-fabric-react/lib/components/DatePicker/DatePicker.js
// module id = 719
// module chunks = 0